<template>
	<div class="row items-center justify-between sm:flex-nowrap">
		<div class="flex grow pl-2" :class="rightColumnClass">
			<ul class="btnList">
				<li>
					<a class="jmiBtn green" @click="$emit('toggle-filters')">
						{{ showFilters ? 'Hide' : 'Show' }} Filters
					</a>
				</li>
				<li>
					<a class="jmiBtn red" @click="$emit('reset-filters')">Reset Filters</a>
				</li>
				<li v-if="hasViewToggle">
					<view-toggle :view-mode="viewMode" @toggle="$emit('toggle-view', $event)" />
				</li>
				<li v-if="hasExport">
					<a class="jmiBtn blue withIcon" @click="$emit('export')">
						<span class="fa-light fa-download"></span>Export
					</a>
				</li>
				<slot name="additional-buttons"></slot>
			</ul>
		</div>
		<div class="mx-2 flex grow items-center justify-end gap-2">
			<slot name="custom-buttons"></slot>
			<div v-if="showAddButton" class="flex grow justify-end">
				<slot name="extra-add-buttons"></slot>
				<div class="fabWrap group my-2 cursor-default sm:my-0" @click="$emit('add-new')">
					<div class="fabLabel">
						<p class="whitespace-nowrap">{{ addButtonLabel }}</p>
					</div>
					<div
						class="fab h-10 min-h-10 w-10 min-w-10 group-hover:bg-green-600 group-active:bg-green-700 sm:h-12 sm:w-12"
					>
						<span class="fa-light fa-plus"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		showFilters: Boolean,
		viewMode: {
			type: String,
			default: 'table'
		},
		hasViewToggle: Boolean,
		hasExport: Boolean,
		showAddButton: Boolean,
		addButtonLabel: String,
		rightColumnClass: {
			type: String,
			default: ''
		}
	},
	emits: ['toggle-filters', 'toggle-view', 'reset-filters', 'export', 'add-new']
}
</script>
